// extracted by mini-css-extract-plugin
export default {"IonToolbar":"Form_IonToolbar__mkstz"};